export default {
  overview: {
    logo: "亿速云",
    billing: {
      header: '账单',
      availableCredit: '账户余额',
      consumptionTip: '本月累计消费',
      addFunds: '充值'
    },
    products: {
      header: '产品',
      ecc: {header: '云服务器 (ECC)', introduction: '稳定、安全、弹性、高性能的云计算服务。'},
      bms: {
        header: '裸金属服务器（BMS）',
        introduction: '为核心数据库、关键应用系统和高性能计算提供卓越的计算性能和数据安全性。'
      },
      mysql: {
        header: 'MySQL 数据库(RDS)',
        introduction: '拥有多重安全保护措施和完善的性能监控体系，提供专业的数据库备份、恢复和优化解决方案。'
      },
    },
    support: {
      header: '支持',
      guide: '指南和教程',
      faq: '常见问题',
      contact: '联系我们'
    },
    rechargeDialog: {

    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-CN/overview.js